module.exports = __webpack_public_path__ + "static/img/CgoRDGORta-AZvQ3ABpZQUYdDcI125.bc7a398.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGORta-AZvQ3ABpZQUYdDcI125.png
// module id = v2Oo
// module chunks = 73